var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.logo)?_c('header',{staticClass:"header_area"},[_c('img',{staticClass:"logo-img",attrs:{"src":_vm.logo,"alt":"logo"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }